import { Component, Input, OnInit } from '@angular/core';
import { Banner } from 'src/app/_model/banner';

import SwiperCore, {
  Autoplay, Navigation, Pagination,
} from "swiper/core";

// install Swiper components
SwiperCore.use([
  Autoplay,
  Navigation,
  Pagination
]);

@Component({
  selector: 'app-slider-banner',
  templateUrl: './slider-banner.component.html',
  styleUrls: ['./slider-banner.component.scss']
})
export class SliderBannerComponent implements OnInit {

  @Input()
  sliders: Banner[] = [];


  @Input() sliderIdentification: string | undefined = '';
  @Input() autoPlay: any = {
    delay: 3000,
  };
  @Input() speed: number = 800;
  @Input() direction: any = 'horizontal';
  @Input() autoHeight: boolean | undefined = false;
  @Input() roundLengths: boolean | undefined = true;
  @Input() slidesPerView: number | undefined = 1;
  @Input() centeredSlides: boolean | undefined = false;
  @Input() spaceBetween: number | undefined = 0;
  @Input() container: any = '.js-slider-home';
  @Input() slideToClickedSlide: boolean | undefined = false;
  @Input() loop: boolean | undefined = true;
  @Input() pagination: any = true;
  // {
  //    // el: '.js-slider-gallery-pagination-home',
  //    // clickable: true,
  // };
  @Input() navigation: any = false;
  @Input() breakpoints: any = {};
  // shortSwipes: false,

  constructor() { }

  ngOnInit(): void {

  }

  onSwiper(swiper: any) {
  }
}
